import { render, staticRenderFns } from "./FrzAvocadoOil.vue?vue&type=template&id=937820fe&lang=true"
import script from "./FrzAvocadoOil.vue?vue&type=script&lang=js"
export * from "./FrzAvocadoOil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports